/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowRightRhombus = createReactComponent(
  "arrow-right-rhombus",
  "IconArrowRightRhombus",
  [
    ["path", { d: "M8 12h13", key: "svg-0" }],
    ["path", { d: "M18 9l3 3l-3 3", key: "svg-1" }],
    ["path", { d: "M5.5 9.5l-2.5 2.5l2.5 2.5l2.5 -2.5z", key: "svg-2" }]
  ]
);

export { IconArrowRightRhombus as default };
//# sourceMappingURL=IconArrowRightRhombus.js.map
